import moment from "moment";
import React from "react";
import { TCRBRecord } from "../../../../../redux/app/crb/@types";
import { TCRBC1 } from "../../../../../redux/app/crb/groups/crb-c";
import { commonUtils } from "../../../../../redux/_common";
import CRBTableRows from "../CRBTableRows";

type OwnProps = {
	crbRecord: TCRBRecord;
	isStrikedOff?: boolean;
};
type CRBC1PreviewProps = OwnProps;
function CRBC1Preview(props: CRBC1PreviewProps) {
	const crbRecord = props.crbRecord as TCRBC1;
	const operationDate = moment(crbRecord.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);

	function renderMain() {
		return (
			<CRBTableRows
				record={crbRecord}
				tableRows={[
					[operationDate, "C", 7, renderItem7()],
					[null, null, 8, renderItem8()],
					[null, null, 9, renderItem9()],
					[null, null, 10, renderItem10()],
					[null, null, 11, renderItem11()],
					[null, null, "NOTE", crbRecord.remarks],
				]}
			/>
		);
	}

	function renderItem7() {
		if (crbRecord.item8.tanks.length > 0) {
			const smtStartDate = crbRecord.item8P1.startDate;
			const smtStartTime = crbRecord.item8P1.startTime;
			const smtEndDate = crbRecord.item8P1.endDate;
			const smtEndTime = crbRecord.item8P1.endTime;

			const startDateTimeLocal = `${smtStartDate}T${smtStartTime}:00${crbRecord.timeZone}`;
			const utcStartTime = moment.utc(startDateTimeLocal);
			const endDateTimeLocal = `${smtEndDate}T${smtEndTime}:00${crbRecord.timeZone}`;
			const utcEndTime = moment.utc(endDateTimeLocal);
			const { placeOfBallast } = crbRecord.item7;
			if (placeOfBallast.place === "AT_SEA") {
				return (
					<>
						<>
							Start - {utcStartTime.format("HH:mm")} hrs (UTC) ({smtStartTime}{" "}
							SMT) on {moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							at Lat {placeOfBallast.startPosition.latitude} / Long{" "}
							{placeOfBallast.startPosition.longitude}
						</>
						<br />
						<>
							Completion - {utcEndTime.format("HH:mm")} hrs (UTC) ({smtEndTime}{" "}
							SMT) on {moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							at Lat {placeOfBallast.startPosition.latitude} / Long{" "}
							{placeOfBallast.startPosition.longitude}
						</>
					</>
				);
			} else if (placeOfBallast.place === "AT_RECEPTION_FACILITY") {
				return (
					<>
						<>
							Start - {utcStartTime.format("HH:mm")} hrs (UTC) ({smtStartTime}{" "}
							SMT) on {moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							at {placeOfBallast.receptionFacilityName},
							{placeOfBallast.portName}
						</>
						<br />
						<>
							Completion - {utcEndTime.format("HH:mm")} hrs (UTC) ({smtEndTime}{" "}
							SMT) on {moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							at {placeOfBallast.receptionFacilityName},
							{placeOfBallast.portName}
						</>
					</>
				);
			} else if (placeOfBallast.place === "IN_PORT") {
				return (
					<>
						<>
							Start - {utcStartTime.format("HH:mm")} hrs (UTC) ({smtStartTime}{" "}
							SMT) on {moment(smtStartDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							at {placeOfBallast.portName}
						</>
						<br />
						<>
							Completion - {utcEndTime.format("HH:mm")} hrs (UTC) ({smtEndTime}{" "}
							SMT) on {moment(smtEndDate, "YYYY-MM-DD").format("DD-MMM-YYYY")}{" "}
							at {placeOfBallast.portName}
						</>
					</>
				);
			}
		}
		return <>----</>;
	}
	function renderItem8() {
		if (crbRecord.item8.tanks.length > 0) {
			const totalLoadedQuantityOfTanks = crbRecord.item8.tanks.reduce<number>(
				(result, tank) => commonUtils.addUp(tank.transferQuantity, result),
				0
			);
			return (
				<>
					<table className="min-w-full table-auto border-collapse">
						<thead className="bg-gray-600">
							<tr>
								<th className="px-4 py-2 border text-center">Tank</th>
								<th className="px-4 py-2 border text-center">
									Quantity Unloaded
								</th>
							</tr>
						</thead>
						<tbody>
							{crbRecord.item8.tanks.map((tank) => {
								return (
									<tr key={tank.selectedTank.id}>
										<td className="px-4 py-2 border text-center">
											{tank.selectedTank.tankCode}
										</td>
										<td className="px-4 py-2 border text-center">
											{tank.transferQuantity}
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>

					<br />
					<h4 className="font-medium uppercase">
						Total Cargo Unloaded: {totalLoadedQuantityOfTanks.toFixed(2)} M³
					</h4>
				</>
			);
		}
		return <>----</>;
	}

	function renderItem9() {
		if (crbRecord.item8.tanks.length > 0) {
			return (
				<h4 className="font-medium uppercase">
					{crbRecord.item9.wereTanksEmptied ? (
						`Yes, all tanks emptied, procedure for emptying & stripping has been performed in accordance with ship's P&A Manual, ${crbRecord.item9.content}`
					) : (
						<>
							<table className="min-w-full table-auto border-collapse">
								<thead className="bg-gray-600">
									<tr>
										<th className="px-4 py-2 border text-center">Tank</th>
										<th className="px-4 py-2 border text-center">
											Quantity Remaining
										</th>
									</tr>
								</thead>
								<tbody>
									{crbRecord.item8.tanks.map((tank) => {
										return (
											<tr key={tank.selectedTank.id}>
												<td className="px-4 py-2 border text-center">
													{tank.selectedTank.tankCode}
												</td>
												<td className="px-4 py-2 border text-center">
													{tank.newQuantity}
												</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</>
					)}
				</h4>
			);
		}
		return <>----</>;
	}
	function renderItem10() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item10.prewashRequired ? "YES" : "NO"}
			</h4>
		);
	}
	function renderItem11() {
		return (
			<h4 className="font-medium uppercase">
				{crbRecord.item11.failure ? (
					<>
						{crbRecord.item11.failureDate && crbRecord.item11.failureTime ? (
							<p>
								Failure Date & Time (SMT): {crbRecord.item11.failureDate},{" "}
								{crbRecord.item11.failureTime} Hrs
							</p>
						) : null}

						<p>
							Nature of failure:{" "}
							{crbRecord.item11.natureOfFailure
								? crbRecord.item11.natureOfFailure
								: null}
						</p>
						<p>
							Reason of failure:{" "}
							{crbRecord.item11.reasonOfFailure
								? crbRecord.item11.reasonOfFailure
								: null}
						</p>
						{crbRecord.item11.operationalDate &&
						crbRecord.item11.operationalTime ? (
							<p>
								Operational Date & Time (SMT):{" "}
								{crbRecord.item11.operationalDate},{" "}
								{crbRecord.item11.operationalTime} Hrs
							</p>
						) : null}
					</>
				) : (
					"NO"
				)}
			</h4>
		);
	}

	return renderMain();
}

export default CRBC1Preview;
